<template>
  <div class="hit-html-html hit-table-responsive">

    <table class="hit-table hit-html-table " :class="{
      'hit-table-striped': !settings || settings.striped !== false,
      'hit-table-bordered': !settings || settings.bordered !== false
    }" >

      <hit_thead :titles="titles" :icons="icons" />
      <hit_tbody :titles="titles" :data="data" :actions="actions" />

    </table>

  </div>
</template>

<script>

import hit_thead from '@core/components/assets/hit_table/hit_thead'
import hit_tbody from '@core/components/assets/hit_table/hit_tbody'

export default{

  components: {hit_thead, hit_tbody},
  props: { titles: Array, data: Array, actions: Array, icons: Array, settings: Object }

}
</script>
